import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ClbHeader,
  ClbHeaderBrand,
  ClbHeaderSelectables,
  ClbSelect,
} from '@celebration/react';
import productLogo from '../../assets/Clb_UI/Product Logo.png';
import { getLanguages } from '../../config/languages';
import { changeLanguage } from '../../utils/utils';
import styles from './loginHeader.module.scss';

const LoginHeader = ({ onLogoDoubleClick }) => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(
    () => localStorage.getItem('system_language') || i18n.language || 'en',
  );
  const languages = useMemo(() => getLanguages(t), [t]);

  const handleLanguageChange = event => {
    const value = event?.target?.value || event?.value;
    if (!value) return;
    setLanguage(value);
    changeLanguage(i18n, value);
  };

  return (
    <div className={styles.loginHeader}>
      <ClbHeader size="sm">
        <ClbHeaderBrand size="sm">
          <div className={styles.brand}>
            <img className={styles.productLogo} alt="logo" src={productLogo} />
            <img
              className={styles.sensoryLogo}
              alt="SensoryOne"
              src={`${process.env.PUBLIC_URL || ''}/SensoryOneLogo.png`}
              onDoubleClick={onLogoDoubleClick}
              style={onLogoDoubleClick ? { cursor: 'pointer' } : undefined}
            />
          </div>
        </ClbHeaderBrand>
        <ClbHeaderSelectables>
          <div className={styles.selectLanguage}>
            <ClbSelect
              options={languages}
              selectStyle="ghost"
              size="sm"
              icon="translate"
              value={language}
              name="language"
              onChange={handleLanguageChange}
              data-testid="login-language-select"
            />
          </div>
        </ClbHeaderSelectables>
      </ClbHeader>
    </div>
  );
};

export default LoginHeader;
